import { useState } from "react"
import { useNavigate } from "react-router"
import { useReduxDispatch } from "@/store/useReduxDispatch"
import { loginThunk } from "@/thunks/authThunks"
import { ensureWishListsThunk } from "@/thunks/wishThunks"
import { BasePage } from "@/components/layout/BasePage"
import { StandardButton } from "@/components/button/StandardButton"
import "./loginPage.scss"

const lastUsername = localStorage.getItem("lastUsername")

const LoginPage = (): JSX.Element => {
  const [username, setUsername] = useState<string | null>(lastUsername)
  const [password, setPassword] = useState<string | null>(null)
  const [isLoading, setIsLoading] = useState<boolean>(false)

  const navigate = useNavigate()
  const dispatch = useReduxDispatch()

  const doLogin = async () => {
    try {
      await dispatch(loginThunk(navigate, username ?? "", password ?? ""))
      await dispatch(ensureWishListsThunk())
      localStorage.setItem("lastUsername", username ?? "")
    } catch (err) {
      alert("Login fejlede")
    }
  }

  return (
    <BasePage className="login-page" title="Login" showHeaderImages>
      <div className="login-page__intro">
        <p>Login her for at benytte Marinas og Christians ønskeliste</p>
      </div>
      <p>Dit navn: </p>
      <input
        type="text"
        value={username ?? ""}
        onChange={(e) => {
          setUsername(e.currentTarget.value)
        }}
      />
      <p>Adgangskode: </p>
      <input
        type="text"
        value={password ?? ""}
        onChange={(e) => {
          setPassword(e.currentTarget.value)
        }}
        onKeyDown={async (e) => {
          if (e.key === "Enter") {
            setIsLoading(true)
            await doLogin()
            setIsLoading(false)
          }
        }}
      />
      <StandardButton
        forceIsLoading={isLoading}
        className="login-page__button"
        width={200}
        title="Login"
        onClick={async () => {
          await doLogin()
        }}
      />
    </BasePage>
  )
}

export default LoginPage
